import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import LicenseRenewalFailOver75YearsBottomSheet from '@di-shared/features/public-service/license-renewal/LicenseRenewalFailOver75Years';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function LicenseRenewalFailOver75YearsBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <LicenseRenewalFailOver75YearsBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
